import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SearchForm from './Search/Search';
import DropdownProfile from './Dropdown/Profile';

import logo from './../../../assets/images/logo.png'
import StoresFilter from './StoresFilter/StoresFilter';
import StoresFilterIcon from './StoresFilter/StoresFilterIcon';
import { getIsMenuCollapsed, setIsMenuCollapsed } from 'src/services/Stores/FilteredStoreService';
import { Button } from 'reactstrap';
import { RefsContext } from 'src/contexts/OnboardingContext';
// import DropdownMegaMenu from './dropdown/mega';

const Header = () => {    
    const [isCollapsed, setIsCollapsed] = useState(getIsMenuCollapsed());
    const refsContext = useContext(RefsContext);

    if (!refsContext) {
      return <></>; // O maneja el caso donde el contexto no está disponible
    }
    const { tooltip3 } = refsContext;

    useEffect(() => {
        const mainAppContent = document.getElementById('mainappcontent');
        const sidebar = document.querySelector('#mainsidebar') as HTMLElement;
        const sidebarIcon = document.querySelector('#mainsidebar-icon') as HTMLElement;
        const mainsidebarcontent = document.querySelector('#mainsidebarcontent') as HTMLElement;
        if (mainAppContent) {
            if (isCollapsed) {
                mainAppContent.style.marginLeft = '60px';
                // if (sidebar) 
                //     sidebar.style.display = 'none';                

                // if (sidebarIcon) 
                //     sidebarIcon.style.display = 'block'; // Asegúrate de que el estilo display sea el adecuado                

                if (mainsidebarcontent) 
                    mainsidebarcontent.style.width = 'auto';
                

            } else {
                mainAppContent.style.marginLeft = ''; // Reset to original margin
                // if (sidebar) 
                //     sidebar.style.display = 'block';                

                // if (sidebarIcon) 
                //     sidebarIcon.style.display = 'none'; // Asegúrate de que el estilo display sea el adecuado                

                if (mainsidebarcontent) 
                    mainsidebarcontent.style.width = ''; // Reset to original width

            }
        }
    }, [isCollapsed]);

    useEffect(() => {
        const handleMenuCollapseChange = () => {
            setIsCollapsed(getIsMenuCollapsed());
        };
    
        // Evento que se dispara cuando el menú se colapsa/expande
        window.addEventListener('menuCollapseChange', handleMenuCollapseChange);
    
        return () => {
            window.removeEventListener('menuCollapseChange', handleMenuCollapseChange);
        };
    }, []);

    //original
        // const mainAppContent = document.getElementById('mainappcontent');
        // if (mainAppContent) {
        //     if (isCollapsed) {
        //         mainAppContent.style.marginLeft = '60px';
        //         // mainAppContent.classList.remove('show');

        //         // agregar style display none a div con id #mainsidebar y poner display a #mainsidebar-icon
        //         const sidebar = document.querySelector('.app-sidebar');
        //         if (sidebar) 
        //             sidebar.classList.remove('show');
                
        //     } else {
        //         mainAppContent.style.marginLeft = ''; // Reset to original margin

        //         // Agregar clase show justo después de app-sidebar collapse
        //         const sidebar = document.querySelector('.app-sidebar.collapse');
        //         if (sidebar) 
        //             sidebar.classList.add('show');
        //     }
        // }

    const handleToggle = () => {
        var newT = !isCollapsed
        setIsMenuCollapsed(newT);
        setIsCollapsed(newT);
    };

    return (
        <div id="mainheader" className="app-header ">
            <div className="navbar-header navbar-collapse" style={{ flex: 1}}>
                <Link to="/dashboard" className="navbar-brand">
                    <span className="navbar-logo">
                        <img src={logo} alt={'logo'} width="150" />
                    </span> 
                </Link>
                <i role="button" className="fa-solid fa-bars fa-xl" style={{ cursor: "pointer" }} onClick={handleToggle}></i>
            </div>
            <div className="navbar-nav" style={{ flex: 5, display: 'flex', justifyContent: 'space-between' }}>
                <SearchForm />
                <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }} >
                <StoresFilterIcon />
                <div style={{ marginLeft: "0.5rem" }} className="btn-group shadow-none" hidden={false} ref={tooltip3}>
                    <button 
                        type="button" 
                        className="btn btn-sm shadow-none btn-primary dropdown-toggle" 
                        data-bs-toggle="dropdown" 
                        aria-expanded="false"
                    >
                        <i className="fa fa-plus me-1"></i>{"  "} &nbsp; &nbsp;
                        Crear &nbsp;
                    </button>
                    <ul className="dropdown-menu">
                        <li><a 
                            className="dropdown-item"
                            hidden={false}
                            onClick={() => { 
                                const currentUrl = new URL(window.location.href);
                                const targetPath = "/clientes/clientes/listado";
                                if (currentUrl.pathname === targetPath) {
                                    currentUrl.searchParams.set("create", "");
                                    window.history.replaceState({}, document.title, currentUrl.toString());
                                } else {
                                    window.open(`${targetPath}?create`, "_self");
                                }
                            }}
                        >Cliente</a></li>
                        <li><a 
                            className="dropdown-item"
                            hidden={false}
                            onClick={() => { 
                                const currentUrl = new URL(window.location.href);
                                const targetPath = "/clientes/cotizaciones/listado";
                                if (currentUrl.pathname === targetPath) {
                                    currentUrl.searchParams.set("create", "");
                                    window.history.replaceState({}, document.title, currentUrl.toString());
                                } else {
                                    window.open(`${targetPath}?create`, "_self");
                                }
                            }}
                        >Cotización</a></li>
                        <li><a 
                            className="dropdown-item"
                            hidden={false}
                            onClick={() => { 
                                const currentUrl = new URL(window.location.href);
                                const targetPath = "/contabilidad/facturas/clientes/listado";
                                if (currentUrl.pathname === targetPath) {
                                    currentUrl.searchParams.set("create", "");
                                    window.history.replaceState({}, document.title, currentUrl.toString());
                                } else {
                                    window.open(`${targetPath}?create`, "_self");
                                }
                            }}
                        >Factura</a></li>
                        <li><a 
                            className="dropdown-item"
                            hidden={false}
                            onClick={() => { 
                                const currentUrl = new URL(window.location.href);
                                const targetPath = "/productos/solicitudes-compra/listado";
                                if (currentUrl.pathname === targetPath) {
                                    currentUrl.searchParams.set("create", "");
                                    window.history.replaceState({}, document.title, currentUrl.toString());
                                } else {
                                    window.open(`${targetPath}?create`, "_self");
                                }
                            }}
                        >Solicitud de compra</a></li>
                    </ul>
                </div>
                <DropdownProfile />
                </div>
            </div>
        </div>
    );
}

export default Header;